export default {
  settings: 'Indstillinger',
  storefront: 'Webshop',
  media: 'Medier',
  style: 'Stil',
  scripts: 'Scripts',
  no_google_place: {
    title: 'Virksomheden er ikke forbundet med nogen Google-lokation',
    description: 'Forbind virksomheden med en Google-lokation',
  },
};
